<div class="activity-tab">

  <!-- Toolbar -->
  <div class="activity-toolbar">
    <h2 class="section-title">Active Sessions</h2>
    <button mat-stroked-button
      [disabled]="isLoading || isRefreshing"
      (click)="onRefreshClick()"
      matTooltip="Auto-refreshes every 5 seconds. Click to refresh now and reset the timer."
      matTooltipPosition="left">
      <mat-progress-spinner *ngIf="isRefreshing" mode="indeterminate" diameter="16" class="btn-spinner"></mat-progress-spinner>
      <mat-icon *ngIf="!isRefreshing">refresh</mat-icon>
      Refresh
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="activity-loading">
    <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
  </div>

  <!-- Error -->
  <div *ngIf="!isLoading && loadError" class="activity-error">
    <mat-icon>error_outline</mat-icon>
    <p>{{ loadError }}</p>
    <button mat-stroked-button (click)="loadActivity()">Retry</button>
  </div>

  <!-- Empty state: VM class not confirmed yet — participants cannot launch VMs -->
  <div *ngIf="!isLoading && !loadError && sessions.length === 0 && hasVmResource && !hasSnapshot"
       class="activity-empty">
    <mat-icon>lock_clock</mat-icon>
    <p class="activity-empty-title">Class not confirmed yet</p>
    <p class="activity-empty-sub">
      Participants cannot start VMs until the class template is created and snapshotted.
      Create the template and snapshot in Settings.
    </p>
    <button mat-stroked-button (click)="goToSettingsVMTemplate.emit()">
      Go to Settings &rarr; VM Template
    </button>
  </div>

  <!-- Empty state: no active sessions (class confirmed or no VM resource) -->
  <div *ngIf="!isLoading && !loadError && sessions.length === 0 && (!hasVmResource || hasSnapshot)"
       class="activity-empty">
    <mat-icon>desktop_access_disabled</mat-icon>
    <p>No active sessions right now.</p>
  </div>

  <!-- Session cards grid -->
  <div *ngIf="!isLoading && !loadError && sessions.length > 0" class="sessions-grid">
    <div *ngFor="let s of sessions" class="session-card">

      <!-- Thumbnail area (always present — shows screenshot or placeholder) -->
      <div class="session-thumb-wrapper">

        <!-- Captured screenshot -->
        <img *ngIf="s.thumbnailData"
             [src]="s.thumbnailData"
             alt="VM screen preview"
             class="session-thumb-img" />

        <!-- Placeholder when no thumbnail yet -->
        <div *ngIf="!s.thumbnailData" class="session-thumb-placeholder">
          <mat-icon>computer</mat-icon>
        </div>

        <!-- Hover overlay: shows VM details -->
        <div class="session-info-overlay">
          <div class="session-info-content">
            <div class="info-row">
              <mat-icon class="info-icon">public</mat-icon>
              <span>{{ s.publicIp || '—' }}</span>
            </div>
            <div class="info-row" *ngIf="s.vmName">
              <mat-icon class="info-icon">tag</mat-icon>
              <span>{{ s.vmName }}</span>
            </div>
            <div class="info-row">
              <mat-icon class="info-icon">schedule</mat-icon>
              <span>{{ getConnectedAt(s) }}</span>
            </div>
            <div class="info-row">
              <span class="status-running overlay-status">CONNECTED</span>
            </div>
          </div>
        </div>

        <!-- (i) badge — always visible, signals hoverable info -->
        <div class="session-info-badge" matTooltip="Hover for VM details">
          <mat-icon>info</mat-icon>
        </div>

        <!-- Thumbnail freshness badge -->
        <span class="session-thumb-age" *ngIf="s.thumbnailUpdatedAt">{{ getThumbnailAge(s) }}</span>
      </div>

      <!-- Card footer: avatar + name + join button -->
      <div class="session-card-footer">
        <div class="session-avatar">{{ (s.userName || '?')[0].toUpperCase() }}</div>
        <span class="session-name">{{ s.userName || 'Unknown' }}</span>

        <button *ngIf="userRole.toLowerCase() !== 'student'"
                mat-flat-button
                color="primary"
                class="join-btn"
                [disabled]="isLaunching"
                (click)="onJoinClick(s)">
          <mat-progress-spinner
            *ngIf="launchingUserId === s.userId"
            mode="indeterminate"
            diameter="14"
            class="join-btn-spinner">
          </mat-progress-spinner>
          <mat-icon *ngIf="launchingUserId !== s.userId">screen_share</mat-icon>
          {{ launchingUserId === s.userId ? 'Joining\u2026' : 'Join' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Join confirmation dialog -->
  <div *ngIf="showJoinConfirm" class="confirm-overlay" (click)="cancelJoin()">
    <div class="confirm-dialog" (click)="$event.stopPropagation()">
      <h3>Join Session?</h3>
      <p>
        You are about to share
        <strong>{{ pendingSession?.userName }}</strong>'s VM session.
        They will be able to see you in their session.
      </p>
      <div class="confirm-actions">
        <button mat-stroked-button (click)="cancelJoin()">Cancel</button>
        <button mat-flat-button color="primary" (click)="confirmJoin()">
          <mat-icon>screen_share</mat-icon> Confirm
        </button>
      </div>
    </div>
  </div>

</div>
